import { transitionDuration } from "@utils/DOMUtilities.js";
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: 0,
      validator(val) {
        if (isNaN(val)) return false;
        return val <= 100 && val >= 0;
      }
    },
    color: {
      type: String,
      default: "dark",
      validator: function (value) {
        return ["primary", "secondary", "success", "danger", "warning", "info", "light", "dark"].includes(value);
      }
    }
  },
  data() {
    return {
      easedVal: 0,
      displayValue: 0
    };
  },
  mounted() {
    setTimeout(() => {
      this.easedVal = this.value;
      this.setDisplayValue();
    }, 1);
  },
  watch: {
    value(val) {
      this.easedVal = val;
      this.$nextTick(this.setDisplayValue);
    }
  },
  methods: {
    setDisplayValue() {
      let range = this.easedVal - this.displayValue;
      if (range === 0) {
        this.displayValue = 0;
        return;
      }
      let current = this.displayValue;
      let increment = this.easedVal > this.displayValue ? 1 : -1;
      let stepTime = Math.abs(Math.floor(transitionDuration(this.$refs.bar) / range));
      let timer = setInterval(() => {
        current += increment;
        this.displayValue = current;
        if (current == this.easedVal) {
          clearInterval(timer);
        }
      }, stepTime);
    }
  }
};